import SliderOrDiv from './SliderOrDiv';
import ImageWithFallback from './ImageWithFallback';
import { commonCarouselSettings } from 'src/lib/constants';
import Homework1Image from 'public/images/home/homework_1.png';
import Homework2Image from 'public/images/home/homework_2.png';
import Homework3Image from 'public/images/home/homework_3.png';
import useBreakpoints from 'src/hooks/useBreakpoints';
import ClientOnlyComponent from './ClientOnlyComponent';
import { AppRoutes } from 'src/lib/routes';
import Link from 'next/link';

const Homework: React.FC = () => {
  const { isScreenMd } = useBreakpoints();

  return (
    <div className="tw-py-16 md:tw-py-24">
      <div className="container">
        <div className="tw-text-center tw-font-styleSans tw-font-semibold tw-text-5xl md:tw-text-6xl tw-leading-none tw-mb-8">
          We’ve done the
          <br />
          homework
        </div>

        <ClientOnlyComponent>
          <SliderOrDiv
            {...commonCarouselSettings}
            isSlider={!isScreenMd}
            slidesToShow={3}
            className={isScreenMd ? 'row' : 'carousel-homework'}
            dots={true}
            arrows={false}
            fade={true}
          >
            <div className="tw-text-center tw-flex-shrink-0 col-md-4">
              <ImageWithFallback
                src={Homework1Image}
                alt=""
                className="tw-h-60 tw-w-auto tw-static tw-inline-block tw-mb-10 tw-object-cover"
              />
              <div className="tw-font-styleSans tw-font-semibold tw-text-2xl tw-leading-none tw-mb-4">
                No tourist traps
              </div>
              <div>
                Skip overrated spots and enjoy unique experiences that are better worth your time.
              </div>
            </div>
            <div className="tw-text-center tw-flex-shrink-0 col-md-4">
              <ImageWithFallback
                src={Homework2Image}
                alt=""
                className="tw-h-60 tw-w-auto tw-static tw-inline-block tw-mb-10 tw-object-cover"
              />
              <div className="tw-font-styleSans tw-font-semibold tw-text-2xl tw-leading-none tw-mb-4">
                Guides you can trust
              </div>
              <div>
                Our team gets on the ground to handpick every activity so we only recommend what we
                love.
              </div>
            </div>
            <div className="tw-text-center tw-flex-shrink-0 col-md-4">
              <ImageWithFallback
                src={Homework3Image}
                alt=""
                className="tw-h-60 tw-w-auto tw-static tw-inline-block tw-mb-10 tw-object-cover"
              />
              <div className="tw-font-styleSans tw-font-semibold tw-text-2xl tw-leading-none tw-mb-4">
                Earth-friendly travel
              </div>
              <div>
                We obsess over each experience to make sure they’re good for wildlife & our planet.
              </div>
            </div>
          </SliderOrDiv>
        </ClientOnlyComponent>

        <div className="tw-text-center tw-mt-14 md:tw-mt-8">
          <Link legacyBehavior prefetch={false} href={AppRoutes.aboutRoute().toPath()}>
            <a className="btn btn-primary tw-rounded-4xl tw-py-3 tw-px-8">our story</a>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Homework;
